export default "__VITE_ASSET__BiCh3nx5__"